const token = localStorage.getItem("token");
const data = localStorage.getItem("data");
const rol = localStorage.getItem("rol");
const user = localStorage.getItem("user");
const company = localStorage.getItem("company");

const AuthSession = { token, data, rol, company, user };

export default AuthSession;
